import React, { createContext, FC, ReactNode, useContext } from "react";

interface AiAgentConversationContextValue {
  conversationId: string | null;
}

const AiAgentConversationContext =
  createContext<AiAgentConversationContextValue>({
    conversationId: null,
  });

export const AiAgentConversationProvider: FC<{
  conversationId: string | null;
  children: ReactNode;
}> = ({ conversationId, children }) => (
  <AiAgentConversationContext.Provider value={{ conversationId }}>
    {children}
  </AiAgentConversationContext.Provider>
);

export function useAiAgentConversationContext(): AiAgentConversationContextValue {
  return useContext(AiAgentConversationContext);
}
